import {
  DELETE_ROUTE_REQUEST,
  EDIT_ROUTE_REQUEST,
  GENERATE_AI_ROUTES_REQUEST,
  GENERATE_AI_ROUTES_SUCCESS,
  LOAD_GENERATE_AI_ROUTE_REQUEST,
  LOAD_GENERATE_AI_ROUTE_SUCCESS,
  LOAD_GENERATE_AI_ROUTES_LIST_REQUEST,
  LOAD_GENERATE_AI_ROUTES_LIST_SUCCESS,
  SAVE_AI_ROUTE_SETTINGS_REQUEST,
  SAVE_AI_ROUTE_SETTINGS_SUCCESS,
  LOAD_INITIAL_DATA_REQUEST,
  LOAD_INITIAL_DATA_SUCCESS,
  LOAD_ROUTES_REQUEST,
  LOAD_ROUTES_SUCCESS,
  SAVE_ROUTE_REQUEST,
  SET_FILTERS,
  SET_LOADING_CLIENTS,
  SET_LOADING_REPORT,
  SET_LOADING_SAVE,
  SET_LOADING_AI_SETTINGS,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ORDER,
  SET_ORDERBY,
  SEARCH,
  SET_WALLET_SUMMARY,
  START_AI_ROUTE_JOB,
  RESTORE_AI_ROUTE_JOB,
  UPDATE_AI_ROUTE_JOB,
  CLEAR_AI_ROUTE_JOB,
  STOP_AI_ROUTE_JOB_POLLING,
  RESUME_AI_ROUTE_JOB_POLLING
} from './routing-constants';

import {
  AIRouteJob,
  RouteAllocation,
  RoutingClient,
  RoutingFilters,
  RoutingListType,
  SaveAIRouteSettingsPayload,
  WalletSummary
} from './routing-interfaces';

export const setLoadingClients = (loading: boolean) => ({
  type: SET_LOADING_CLIENTS,
  loading
});

export const setLoadingSave = (loading: boolean) => ({
  type: SET_LOADING_SAVE,
  loading
});

export const setLoadingAiSettings = (loading: boolean) => ({
  type: SET_LOADING_AI_SETTINGS,
  loading
});

export const setLoadingReport = (loading: boolean) => ({
  type: SET_LOADING_REPORT,
  loading
});

export const setFilters = (filters: any) => ({
  type: SET_FILTERS,
  filters
});

export const loadInitialDataRequest = (
  filters?: any,
  id?: string,
  month?: number,
  year?: number,
  routeType?: string
) => ({
  type: LOAD_INITIAL_DATA_REQUEST,
  filters,
  id,
  month,
  year,
  routeType
});

export const loadInitialDataSuccess = (payload: {
  clients: RoutingClient[];
  cityLocales: any[];
  allocations?: RouteAllocation[];
}) => ({
  type: LOAD_INITIAL_DATA_SUCCESS,
  payload
});

export const saveRouteRequest = (allocations: any) => ({
  type: SAVE_ROUTE_REQUEST,
  allocations
});

export const editRouteRequest = (allocations: any, id: string) => ({
  type: EDIT_ROUTE_REQUEST,
  allocations,
  id
});

export const deleteRouteRequest = (userExternalCode: string, userName: string) => ({
  type: DELETE_ROUTE_REQUEST,
  userExternalCode,
  userName
});

export const loadRoutesRequest = (filters?: RoutingFilters, typeList?: RoutingListType) => ({
  type: LOAD_ROUTES_REQUEST,
  filters,
  typeList
});

export const loadRoutesSuccess = (payload: any) => ({
  type: LOAD_ROUTES_SUCCESS,
  payload
});

export const setPage = (page: number) => ({
  type: SET_PAGE,
  page
});

export const setRowsPerPage = (rowsPerPage: number) => ({
  type: SET_ROWS_PER_PAGE,
  rowsPerPage
});

export const setOrder = (order: string) => ({
  type: SET_ORDER,
  order
});

export const setOrderBy = (orderBy: string) => ({
  type: SET_ORDERBY,
  orderBy
});

export const search = (queryText?: string) => ({
  type: SEARCH,
  queryText
});

export const setWalletSummary = (walletSummary: WalletSummary | null) => ({
  type: SET_WALLET_SUMMARY,
  walletSummary
});

export const generateAIRoutesRequest = (payload: { userExternalCode: string }) => ({
  type: GENERATE_AI_ROUTES_REQUEST,
  payload
});

export const generateAIRoutesSuccess = (payload: any) => ({
  type: GENERATE_AI_ROUTES_SUCCESS,
  payload
});

export const loadGenerateAIRoutesListRequest = (params?: {
  userExternalCodes?: string;
  limit?: number;
  skip?: number;
}) => ({
  type: LOAD_GENERATE_AI_ROUTES_LIST_REQUEST,
  params
});

export const loadGenerateAIRoutesListSuccess = (payload: { data: any[]; count: number }) => ({
  type: LOAD_GENERATE_AI_ROUTES_LIST_SUCCESS,
  payload
});

export const loadGenerateAIRouteRequest = (id: string) => ({
  type: LOAD_GENERATE_AI_ROUTE_REQUEST,
  id
});

export const loadGenerateAIRouteSuccess = (payload: any) => ({
  type: LOAD_GENERATE_AI_ROUTE_SUCCESS,
  payload
});

export const saveAIRouteSettingsRequest = (payload: SaveAIRouteSettingsPayload) => ({
  type: SAVE_AI_ROUTE_SETTINGS_REQUEST,
  payload
});

export const saveAIRouteSettingsSuccess = (userExternalCode: string) => ({
  type: SAVE_AI_ROUTE_SETTINGS_SUCCESS,
  userExternalCode
});

export const startAIRouteJob = (job: AIRouteJob) => ({
  type: START_AI_ROUTE_JOB,
  job
});

export const restoreAIRouteJob = () => ({
  type: RESTORE_AI_ROUTE_JOB
});

export const updateAIRouteJob = (job: Partial<AIRouteJob>) => ({
  type: UPDATE_AI_ROUTE_JOB,
  job
});

export const clearAIRouteJob = () => ({
  type: CLEAR_AI_ROUTE_JOB
});

export const stopAIRouteJobPolling = () => ({
  type: STOP_AI_ROUTE_JOB_POLLING
});

export const resumeAIRouteJobPolling = () => ({
  type: RESUME_AI_ROUTE_JOB_POLLING
});
